import { Button } from "antd"
import { ReactNode } from "react"
import { BillingStateAction, BillingStateDescription, NoBillingSpacesCard } from "../styles"

export default function BillingStateCard({
    title,
    description,
    actionLabel,
    onAction
}: {
    title: ReactNode
    description?: ReactNode
    actionLabel?: string
    onAction?: () => void
}) {
    return (
        <NoBillingSpacesCard>
            <BillingStateDescription>
                <h4>{title}</h4>
                {description && <p>{description}</p>}
                {actionLabel && onAction && (
                    <BillingStateAction>
                        <Button onClick={onAction}>
                            {actionLabel}
                        </Button>
                    </BillingStateAction>
                )}
            </BillingStateDescription>
        </NoBillingSpacesCard>
    )
}
